import { create } from "zustand";
import * as Models from "../Models";

type azureState = {
  // isUploadingDocuments: boolean;
  // isRemovingDocuments: boolean;
  requests: Models.AzureRequest[];
  connectionIssue: boolean;
  getIsLoading?: () => boolean;
  requestAdd?: (request: Models.AzureRequest) => void;
  requestRemove?: (request: Models.AzureRequest) => void;
};

const azureStore = create<azureState>((set, get) => ({
  // isUploadingDocuments: false,
  // isRemovingDocuments: false,
  requests: [],
  connectionIssue: false,

  requestAdd: (request: Models.AzureRequest) => {
    set((state) => ({
      requests: state.requests.concat(request),
    }));
  },

  requestRemove: (request: Models.AzureRequest) => {
    set((state) => ({
      requests: state.requests.filter((r) => r.url !== request.url),
    }));
  },

  getIsLoading: () => {
    return (
      get().requests.filter(
        (r) =>
          r.url.indexOf("documents") === -1 &&
          r.url.indexOf("powerbi") === -1 &&
          r.url.indexOf("suggestions") === -1 &&
          r.url.indexOf("jira") === -1
      ).length > 0
    );
  },

  // uploadingDocuments: (value: boolean) => {
  //   set({ isUploadingDocuments: value });
  // },

  // removingDOcuments: (value: boolean) => {
  //   set({ isRemovingDocuments: value });
  // },
}));

export default azureStore;
